import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=093e49f8&scoped=true&"
import script from "./Battle.vue?vue&type=script&lang=js&"
export * from "./Battle.vue?vue&type=script&lang=js&"
import style0 from "./Battle.vue?vue&type=style&index=0&id=093e49f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093e49f8",
  null
  
)

export default component.exports